module.exports = __webpack_public_path__ + "d8d974bdd3a8f162b4c8e1045328daf7.svg";